import { SaisieEcran } from '@/components/saisie/saisie-ecran';
import { exigerSession } from '@/lib/garde-session';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: ({ location }) => {
    exigerSession(location.href);
  },
  component: SaisieEcran,
});
